export default __webpack_public_path__ + "static/media/assembly_5.263fb167.webp";